import React, { useContext, useEffect, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { ImMap2 } from "react-icons/im";
import { LiaSlidersHSolid } from "react-icons/lia";
import { useLocation, useNavigate } from "react-router-dom";
import HookSortedPart from "../../../../components/hookHomeTopBar/hookSortedPart";
import ToolbarFilterPopup from "../../../../components/hookHomeTopBar/toolbarFilterPopup";
import { AppContext } from "../../../../context/AppContext";
import { TopBarType } from "../homeTopBar";
import imgMap from '../../../../image/blocMap.webp'
import { isTypedRestaurantFilter } from "../../../../components/types/restaurantTypes";
import { getVisibleFilters, Restaurant } from "../../../../components/types/types";
import { filterRestaurantsWithFilters } from "../../../../context/RestaurantContext";


const listeFavFilter = ["Ouvert", "Prix","Terrasse extérieure","Chèque-vacances","Type de restaurant", "Carte ticket restaurant", "Stationnement facile","Ingrédients de saison"]
const classicFilters = ["Terrasse extérieure","Chèque-vacances","Carte ticket restaurant","Stationnement facile","Ingrédients de saison"];

export const openOptions = [
  "Ouvert maintenant",
  "Ouvert ce midi",
  "Ouvert ce soir",
  "Ouvert demain midi",
  "Ouvert demain soir",
];
interface TopBarToolbarProps {
  type: TopBarType;
  fetchSections: (url: string, elem:string, options?: RequestInit, isInitialLoad?: boolean) => void;
  hasNeighborHood:[string,string[][]][],
  setShowAll: React.Dispatch<React.SetStateAction<number>>,
  routeCity?:string,
  baseSortSection:string,
  getNeighborhoodResultCount: (neighborhoods: string[]) => number;
  toolbarRestaurants: Restaurant[];
  routeFilter?: string;
}

const TopBarToolbar: React.FC<TopBarToolbarProps> = ({ type ,routeCity,baseSortSection, fetchSections, hasNeighborHood,setShowAll, getNeighborhoodResultCount, toolbarRestaurants,routeFilter}) => {
    const {filterChoose,setShowFilterTel,setShowCookies,setPreferencesCookies,setIntentGoMap,openSearchPage,intentGoMap,setFilterChoose,currentNeighborhood} = useContext(AppContext)
    const visibleFilterChoose = getVisibleFilters(filterChoose);
    const navigate = useNavigate()
    const location = useLocation()
    const filtersToShow = hasNeighborHood.length > 0 ? ["Quartier",...listeFavFilter] : listeFavFilter;
    const [activePopupFilter,setActivePopupFilter] = useState<string |null>(null)
    const toolbarScrollRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
      if(!openSearchPage && toolbarScrollRef.current) {
        toolbarScrollRef.current?.scrollTo({
          left: 0,
          behavior: "auto",
        });
      }
    },[openSearchPage])

  const shouldShowToolbarFilter = (filter: string) => {
    if (!classicFilters.includes(filter)) return true;
    if (filterChoose.includes(filter)) return true;

    const filtersWithCurrent = [...filterChoose, filter];
    const resultCount = filterRestaurantsWithFilters(toolbarRestaurants ?? [],filtersWithCurrent).length;

    return resultCount > 0;
  };

    const handleMap = () => {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        if (cookie) {
            const cookieValue = cookie.split('=')[1];
            try {
                const decode = decodeURIComponent(cookieValue)
                const cookieData = JSON.parse(decode);
                if (cookieData['perform-analytics']) {
                    setShowFilterTel(false)
                    navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,returnState: {...(location.state ?? {}),topBarMode: "search"}}});
                } else {
                    setShowCookies(true)
                    setPreferencesCookies(true) 
                    setIntentGoMap(1)
                }
            } catch (error) {
                setShowCookies(true)
                setPreferencesCookies(true)
                setIntentGoMap(1)
            }
        } else {
            setShowCookies(true)
            setPreferencesCookies(true)
            setIntentGoMap(1)
        }
    }
    useEffect(() => {
        if(intentGoMap === 2) {
            setShowFilterTel(false)
            setIntentGoMap(0)
            navigate(`/map?via=home`, {state: {routeCity,returnTo: `${location.pathname}${location.search}`,returnState: {...(location.state ?? {}),topBarMode: "search"}}});
        }
    },[intentGoMap])


    const popupFilters = ["Ouvert", "Prix", "Quartier"];


    const handleToolbarFilterClick = (filter: string) => {
      if (filter === "Type de restaurant") {
        setShowAll(3);
        return;
      }
      if (popupFilters.includes(filter)) {
        setActivePopupFilter(filter);
        return;
      }

      if (classicFilters.includes(filter)) {
        setFilterChoose((prev) => {
          const nextFilters = prev.includes(filter) ? prev.filter((elem) => elem !== filter) : [...prev, filter];
          if (!routeCity && !routeFilter) {
              navigate(nextFilters.length > 0 ? "/" : "/restaurants",{state: { topBarMode: "search" }}
              );
          }
          return nextFilters;
      });
      }

    };
    let hasChevronFilter = (filter:string) => {
      return filter === "Type de restaurant" || popupFilters.includes(filter);
    }

  const isToolbarFilterActive = (filter: string) => {
    if (filter === "Ouvert") {
      return filterChoose.some(
        (elem) => typeof elem === "string" && openOptions.includes(elem)
      );
    }

    if (filter === "Type de restaurant") {
      return filterChoose.some(
        (elem) =>
          typeof elem === "string" &&
          isTypedRestaurantFilter(elem)
      );
    }
    if(filter === 'Prix') {
      return filterChoose.some(
        (elem) =>
          Array.isArray(elem) &&
          elem.length === 2 &&
          elem.every((num) => typeof num === "number")
      );
    }
    if(filter === 'Quartier') {
      return currentNeighborhood.length > 0;
    }
    return filterChoose.some((elem) => elem === filter);
  };

  return (
    <>
    <div className={`topBarToolbar XsmallText ${type}`}>
      {type === "primary" ? (
        <div className="mainToolBar XsmallText">
            <div className="mapPart midWhiteRoundButton" onClick={handleMap}>
                <img src={imgMap} decoding="async" loading="lazy" alt="map" />
                <ImMap2 size={17} className="icon"/>
                <span>Ouvrir la map</span>
            </div>
            <HookSortedPart fetchSections={fetchSections} baseSortSection={baseSortSection}/>
        </div>
      ) : (<>
          <div className="firstSlidePart primaryBack">
            <span className="topBarToolButton smallWhiteRoundButton filterButton" onClick={() => setShowFilterTel(true)}>
              <LiaSlidersHSolid size={15} />
              Filtres
              {visibleFilterChoose && visibleFilterChoose.length > 0 && <span className="flexAllCenter XsmallText">{visibleFilterChoose.length}</span>}
            </span>
            <div className="shadowLeft"></div>
          </div>
          <div className="scndSlydePart" ref={toolbarScrollRef}>
            {filtersToShow.filter(shouldShowToolbarFilter).map((elem) => {
              const isActive = isToolbarFilterActive(elem);
              const hasChevron = hasChevronFilter(elem)
              return <span key={elem} className={`topBarToolButton smallWhiteRoundButton ${isActive ? "isActiveGold" : ""}`} onClick={() => handleToolbarFilterClick(elem)}>
                {elem}
                {hasChevron && <FiChevronDown size={15}/>}
              </span>
            })}
          </div>
          <div className="shadowRight"></div>
        </>
      )}
      <div className="shadowBottomToolBar"></div>
    </div>
    {activePopupFilter && (
      <ToolbarFilterPopup toolbarRestaurants={toolbarRestaurants} getNeighborhoodResultCount={getNeighborhoodResultCount} filterType={activePopupFilter} onClose={() => setActivePopupFilter(null)} hasNeighborHood={hasNeighborHood} />
    )}
    </>
  );
};

export default TopBarToolbar;